import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageSquare, X } from "lucide-react";
import { useChat } from "../context/ChatContext";

const AUTO_KEY = "ba_assistant_autoopened";

// Sichtbare Launcher-Leiste statt kleiner Bubble + einmaliges Auto-Öffnen.
export default function AssistantLauncher() {
  const { openChat, open } = useChat();
  const [visible, setVisible] = useState(true);
  const fired = useRef(false);

  useEffect(() => {
    if (localStorage.getItem(AUTO_KEY)) return;

    const autoOpen = () => {
      if (fired.current) return;
      fired.current = true;
      localStorage.setItem(AUTO_KEY, "1");
      openChat();
      cleanup();
    };

    const timer = setTimeout(autoOpen, 15000);
    const onScroll = () => {
      const scrolled =
        (window.scrollY + window.innerHeight) /
        document.documentElement.scrollHeight;
      if (scrolled >= 0.5) autoOpen();
    };
    const cleanup = () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", onScroll);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return cleanup;
  }, [openChat]);

  if (open) return null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="assistant-launcher"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          className="fixed bottom-24 right-4 z-40 w-[300px] max-w-[calc(100vw-2rem)] md:bottom-6 md:right-6"
        >
          <button
            data-testid="launcher-open-btn"
            onClick={openChat}
            className="group flex w-full items-center gap-3 rounded-xl border border-[#3DDC97]/30 bg-[#14161B]/95 p-3 text-left shadow-xl backdrop-blur-md transition-colors hover:border-[#3DDC97]/60"
          >
            <span className="pulse-ring flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#3DDC97] text-[#0E0F12]">
              <MessageSquare size={20} />
            </span>
            <span className="text-[13px] leading-snug text-gray-200">
              Chatten Sie mit unserem{" "}
              <span className="font-semibold text-white">BA Media Assistenten</span> – Ihre
              Fragen gehen direkt an unser Team.
            </span>
          </button>
          <button
            data-testid="launcher-dismiss-btn"
            onClick={() => setVisible(false)}
            aria-label="Ausblenden"
            className="absolute -right-2 -top-2 flex h-6 w-6 items-center justify-center rounded-full border border-white/15 bg-[#0E0F12] text-gray-400 hover:text-white"
          >
            <X size={13} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
